module.exports = __webpack_public_path__ + "7d52674bb7744c796a7b7d93290da7e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/8_G2.mp3
// module id = 105
// module chunks = 0